import React from 'react';

import Collection from '../components/Collection/Collection';
import CollectionItems from '../components/Collection/CollectionItems';
import CollectionPagination from '../components/Collection/CollectionPagination';
import Container from '../components/Container';
import HeadingContext from '../components/Heading/HeadingContext';
import { LoadingCard } from '../components/Loading';
import { ModalProps } from '../components/Modal/ModalContextProvider';
import EventCard from '../models/events/EventCard';

const EventsModal = ({ lat, lon }: ModalProps<{ lat: number; lon: number }>) => {
  return (
    <Container>
      <HeadingContext>
        <Collection
          opts={{ filter: { future: ['true'], lat: [lat.toString()], lon: [lon.toString()] } }}
          resourceType="events"
        >
          <CollectionItems<'events'> onLoad={LoadingCard}>
            {(item) => <EventCard item={item} key={item.id} />}
          </CollectionItems>
          <CollectionPagination />
        </Collection>
      </HeadingContext>
    </Container>
  );
};

export default EventsModal;
